<form #form="ngForm" autocomplete="off">
    <div *ngFor="let approvalObserver of approvalObservers; index as i" class="app-grid observers-wrapper">
        <mat-form-field class="columns-4">
            <mat-label appRemoveAriaOwns>{{ 'time-off-v3.personOrGroup' | translate }}</mat-label>
            <mat-select
                [(ngModel)]="approvalObserver.timeOffApprovalObserverTypeId"
                name="approvalObserverType-{{ i }}"
                (selectionChange)="wipeSpecificPerson($event, approvalObserver)"
            >
                <mat-option
                    *ngFor="let observerType of observerTypes"
                    [value]="observerType.id"
                    [disabled]="isObserverTypeUsed(observerType.id)"
                >
                    {{ observerType.name | appTranslateOptions: approvalObserverTypeDisplay }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field
            class="columns-4 margin-left-2"
            *ngIf="approvalObserver.timeOffApprovalObserverTypeId === specificPersonObserverTypeId"
        >
            <mat-label>{{ 'time-off-v3.person' | translate }}</mat-label>
            <ui-employee-autocomplete
                name="specificPerson-{{ i }}"
                #specificPerson="ngModel"
                [ngModel]="approvalObserver.observer"
                (ngModelChange)="approvalObserver.observerId = $event.id"
                placeholder="{{ 'time-off-v3.selectAnEmployee' | translate }}"
                [allowNone]="false"
                required
            ></ui-employee-autocomplete>
        </mat-form-field>
        <ui-button type="ghost" (click)="removeApprovalObserver(approvalObserver)">{{
            'time-off-v3.remove' | translate
        }}</ui-button>
    </div>
    <ui-button type="link" (click)="addApprovalObserver()"
        >{{ 'time-off-v3.addNotificationIcon' | translate }}<i class="fa fa-plus margin-left-1"></i
    ></ui-button>
</form>
